import { useEffect } from "react";
import Backend from "../utils/api.js";
import {
  Box,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { withRouter } from "react-router-dom";
import pinpointLogo from "../assets/pinpoint_no_bg.svg";

function logout() {
  localStorage.removeItem("user");
  Backend.casLogout().then((res) => {
    if (res.redirect) {
      setTimeout(() => window.location.replace(res.redirect), 3000);
    } else {
      setTimeout(() => window.location.replace("/"), 3000);
    }
  });
}

function LogoutCas() {
  useEffect(() => {
    logout();
  }, [])

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={10} mx={"auto"} maxW={"md"} py={12} px={6}>
        <Stack align={"center"} spacing={4}>
          <Image
            width="5em"
            src={pinpointLogo}
            alt="pinpoint logo"
          />
          <Heading fontSize={"5xl"} fontWeight="bold" color="gray.800">
            Pinpoint
          </Heading>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"md"}
          p={8}
        >
          <Text fontSize={"md"} color={"gray.600"} align={"center"} lineHeight="tall">
            Thanks for using Pinpoint! You will be redirected to the CAS signout page in 3 seconds.
          </Text>
        </Box>
      </Stack>
    </Flex>
  );
}

export default withRouter(LogoutCas);
